<div class="pageheader">
  <div class="page-title">
    <h1>Mail Settings</h1>
    <div class="btn-group">
      <button class="btn btn-link" (click)="thePane.refresh()">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>
    </div>
  </div>
</div>

<div class="container container-fixed">
  <div class="row">
    <div class="col-sm-12">

      <app-mail-settings-pane #thePane></app-mail-settings-pane>

    </div>
  </div>
</div>
